import { getVariationColorPalette } from './getVariationColorPalette';

const getVariationFillColor = (index: number) => {
  const variationColors = getVariationColorPalette();
  return variationColors[index % variationColors.length];
};

export { getVariationFillColor };
